import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://localhost:7001/api',
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000, // 30 seconds — Start My Day can take 10+ seconds on first sync
});

// Token is injected by the auth interceptor set up in App.tsx
// This allows access to the React auth context from outside components
let tokenGetter: (() => Promise<string>) | null = null;

export function setTokenGetter(getter: () => Promise<string>) {
  tokenGetter = getter;
}

// Principal context — when an EA selects a principal, this ID is appended
// to all API requests as forExecutiveUserId. Set by PrincipalContext.
let _activePrincipalId: string | null = null;

export function setActivePrincipalId(id: string | null) {
  _activePrincipalId = id;
}

apiClient.interceptors.request.use(async (config) => {
  // Auth token injection
  if (tokenGetter) {
    try {
      const token = await tokenGetter();
      config.headers.Authorization = `Bearer ${token}`;
    } catch {
      // Token expired — will get 401, handled by response interceptor
    }
  }

  // Principal context injection — append forExecutiveUserId to all requests
  // when an EA has selected a principal. Does NOT override explicit params.
  if (_activePrincipalId && !config.params?.forExecutiveUserId) {
    config.params = { ...config.params, forExecutiveUserId: _activePrincipalId };
  }

  return config;
});

export default apiClient;
